import ProdutoDciModel from "../../models/produto/produtoDciModel";
import { iServiceCached } from "../base/iServiceCached";

class ProdutoDciService extends iServiceCached<ProdutoDciModel> {
    constructor() {
        super("ProdutoDci");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.codigo + " - " + p.descricao,
        }));
    }
}

export default new ProdutoDciService();
